// from mui documentation

import React from 'react'
import { NumericFormat } from 'react-number-format'

export const DollarInputFormatAdapter = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
      thousandSeparator
      valueIsNumericString
      decimalScale={0}
      suffix='.00'
      prefix='$'
    />
  )
})

export const dollarInputFormatAdapter__slotProps = {
  input: {
    component: DollarInputFormatAdapter,
  },
}
